export const SITE = {
  name: "CleanMyCar",
  city: "Ghaziabad",
  phoneDisplay: "+91 9762013403",
  phoneDial: "+919762013403",
  whatsapp: "919762013403",
  waMessage: "Hi CleanMyCar! I'd like to book a doorstep car wash.",
  email: "cleanmycarhub@gmail.com",
  tagline: "Premium. Safe. At Your Doorstep.",
  areas: "Serving Ghaziabad: Indirapuram, Vaishali, Vasundhara, Kaushambi, Raj Nagar & nearby (pincodes 201001 to 201014).",
};

export const waLink = (msg) =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(msg || SITE.waMessage)}`;

export const formatPrice = (n) => `₹${Number(n).toLocaleString("en-IN")}`;

export const VEHICLES = [
  { vkey: "sedan", label: "Hatchback / Sedan" },
  { vkey: "suv", label: "SUV / MUV" },
];

export const PLAN_TIERS = [
  { key: "2", title: "2 Washes Per Month", sub: "(Every 15 Days)", save: 200,
    vehicles: [
      { vkey: "sedan", label: "Hatchback / Sedan", original: 799, price: 599 },
      { vkey: "suv", label: "SUV / MUV", original: 899, price: 699 },
    ] },
  { key: "4", title: "4 Washes Per Month", sub: "(Weekly)", save: 300,
    vehicles: [
      { vkey: "sedan", label: "Hatchback / Sedan", original: 1499, price: 1199 },
      { vkey: "suv", label: "SUV / MUV", original: 1599, price: 1299 },
    ] },
];

export const findCombo = (planKey, vkey) => {
  const p = PLAN_TIERS.find((t) => t.key === planKey);
  if (!p) return null;
  const v = p.vehicles.find((x) => x.vkey === vkey);
  if (!v) return null;
  return { ...v, planKey: p.key, planTitle: p.title, planSub: p.sub, save: p.save, sku: `${vkey}_${p.key}`, label: `${v.label} · ${p.title}` };
};

export const ADDON = {
  key: "wipe_care",
  title: "Everyday Exterior Wipe Care",
  desc: "Microfiber wipe every morning. Dust-free and shiny, all month.",
  price: 300,
  note: "Available with any washing plan",
};

export const DIFFERENCE = {
  most: [
    "Use the same dirty cloth across multiple cars",
    "Only wipe dust, no actual deep cleaning",
    "Cause micro scratches that build up over time",
    "No interior care or dashboard treatment",
    "Untrained workers with no standard process",
  ],
  us: [
    "Foam wash for thorough exterior deep cleaning",
    "Interior vacuum cleaning after every wash",
    "Dashboard polish for a factory fresh finish",
    "Separate fresh microfiber cloth for every single car",
    "Professional equipment for safe, scratch free results",
  ],
};

export const HOW_IT_WORKS = [
  { n: "01", title: "Book Your Slot", body: "Choose your preferred date and time. Book online in under a minute." },
  { n: "02", title: "We Come to You", body: "Our professional team arrives at your home, office, or society on time." },
  { n: "03", title: "Premium Foam Wash", body: "Full foam exterior wash, interior vacuum, and dashboard polish, every time." },
  { n: "04", title: "Enjoy the Result", body: "Step into a spotless, professionally cleaned car, looking brand new." },
];

export const TESTIMONIALS = [
  {
    initials: "RK",
    name: "Rohit K.",
    meta: "Haridwar, Uttarakhand",
    rating: 5,
    text: "After switching from regular wiping to this service, the difference was visible from the very first wash. The car looks genuinely clean, not just wiped.",
  },
  {
    initials: "PS",
    name: "Priya S.",
    meta: "Haridwar, Uttarakhand",
    rating: 5,
    text: "Very convenient and professional. They came on time and did a thorough job inside and out. The car looks much better after every wash.",
  },
  {
    initials: "AM",
    name: "Amit M.",
    meta: "Haridwar, Uttarakhand",
    rating: 5,
    text: "Finally a service that doesn't damage the paint. I can see the difference: no swirl marks, no scratches. Worth every rupee.",
  },
];

export const TRANSPARENCY = {
  intro:
    "We believe in complete honesty about how we deliver our service. Here's what you should know:",
  points: [
    "To deliver a proper high pressure foam wash, we use your water and electricity connection. This allows us to bring professional grade results directly to your doorstep.",
    "No extra charges are applied for water or electricity usage. The price you see is the price you pay.",
    "If electricity is not available during a scheduled wash, that wash will be skipped and not charged, no questions asked.",
  ],
};
